import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BlockIcon from "@mui/icons-material/Block";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CategoryIcon from "@mui/icons-material/Category";
import CoffeeIcon from "@mui/icons-material/Coffee";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import DiningIcon from "@mui/icons-material/Dining";
import ErrorIcon from "@mui/icons-material/Error";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import FastfoodOutlinedIcon from "@mui/icons-material/FastfoodOutlined";
import FeedbackIcon from "@mui/icons-material/Feedback";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import HomeIcon from "@mui/icons-material/Home";
import HotelIcon from "@mui/icons-material/Hotel";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import LocalPizzaOutlinedIcon from "@mui/icons-material/LocalPizzaOutlined";
import LunchDiningIcon from "@mui/icons-material/LunchDining";
import LunchDiningOutlinedIcon from "@mui/icons-material/LunchDiningOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PaidIcon from "@mui/icons-material/Paid";
import PanToolIcon from "@mui/icons-material/PanTool";
import ParkIcon from "@mui/icons-material/Park";
import PaymentIcon from "@mui/icons-material/Payment";
import PeopleIcon from "@mui/icons-material/People";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  BALANCE,
  BATCH_TRANSACTIONS,
  CHARGES,
  DASHBOARD,
  DENIED_ENTRIES,
  DIETARY_BOOKINGS,
  DIETARY_OPTIONS,
  DIETARY_TOTALS,
  ENTRIES,
  ENTRIES_TOTALS,
  FEEDBACK,
  FEES,
  HOLIDAYS,
  LIMITS,
  MEAL_BOOKING_SETTINGS,
  MEAL_BOOKINGS,
  MEAL_BOOKINGS_TOTALS,
  MEAL_PLAN_INTEGRITY_ERRORS,
  MEAL_PLANS,
  MENU_ITEM_CATEGORIES,
  MENU_ITEMS,
  MENU_STRUCTURES,
  MENU_TEMPLATES,
  NOTIFICATIONS,
  ORDERS,
  PROTECTED,
  RESIDENCES,
  SEMESTER_MENUS,
  SURVEYS,
  SYSTEM,
  TERM_HOLIDAYS,
  TIMES,
  TRANSACTIONS,
  UPCOMING_MEALS,
  USERS,
} from "constants/routes";

export const general = [
  {
    name: "Dashboard",
    url: PROTECTED + DASHBOARD,
    icon: HomeIcon,
  },
  {
    name: "Users",
    url: PROTECTED + USERS,
    icon: PeopleIcon,
  },
  {
    name: "Push Notifications",
    url: PROTECTED + NOTIFICATIONS,
    icon: NotificationsIcon,
  },
  {
    name: "Feedback",
    url: PROTECTED + FEEDBACK,
    icon: FeedbackIcon,
  },
  {
    name: "Surveys",
    url: PROTECTED + SURVEYS,
    icon: AssignmentIcon,
  },
];

export const mealPlans = [
  {
    name: "Meal Plans",
    url: PROTECTED + MEAL_PLANS,
    icon: RestaurantIcon,
  },
  {
    name: "Integrity Errors",
    url: PROTECTED + MEAL_PLAN_INTEGRITY_ERRORS,
    icon: ErrorIcon,
  },
];

export const transactions = [
  {
    name: "Transactions",
    url: PROTECTED + TRANSACTIONS,
    icon: PaidIcon,
  },
  {
    name: "Batch Transactions",
    url: PROTECTED + BATCH_TRANSACTIONS,
    icon: FileUploadIcon,
  },
  {
    name: "Charges",
    url: PROTECTED + CHARGES,
    icon: AttachMoneyIcon,
  },
  {
    name: "Fees",
    url: PROTECTED + FEES,
    icon: PaymentIcon,
  },
  {
    name: "Limits",
    url: PROTECTED + LIMITS,
    icon: PanToolIcon,
  },
];

export const entries = [
  {
    name: "Entries",
    url: PROTECTED + ENTRIES,
    icon: DiningIcon,
  },
  {
    name: "Entry Totals",
    url: PROTECTED + ENTRIES_TOTALS,
    icon: LunchDiningIcon,
  },
  {
    name: "Denied Entries",
    url: PROTECTED + DENIED_ENTRIES,
    icon: BlockIcon,
  },
];

export const mealBookings = [
  {
    name: "Dietary Requirements",
    url: PROTECTED + DIETARY_BOOKINGS,
    icon: LocalDiningIcon,
  },
  {
    name: "Dietary Requirements Totals",
    url: PROTECTED + DIETARY_TOTALS,
    icon: LunchDiningOutlinedIcon,
  },
  {
    name: "Meal Bookings",
    url: PROTECTED + MEAL_BOOKINGS,
    icon: MenuBookIcon,
  },
  {
    name: "Booking Totals",
    url: PROTECTED + MEAL_BOOKINGS_TOTALS,
    icon: FastfoodOutlinedIcon,
  },
  {
    name: "Meal Orders",
    url: PROTECTED + ORDERS,
    icon: LocalPizzaOutlinedIcon,
  },
];

export const mealMenus = [
  {
    name: "Menu Item Categories",
    url: PROTECTED + MENU_ITEM_CATEGORIES,
    icon: CategoryIcon,
  },
  {
    name: "Dietary Options",
    url: PROTECTED + DIETARY_OPTIONS,
    icon: LocalDiningIcon,
  },
  {
    name: "Menu Items",
    url: PROTECTED + MENU_ITEMS,
    icon: CoffeeIcon,
  },
  {
    name: "Menu Structures",
    url: PROTECTED + MENU_STRUCTURES,
    icon: AccountTreeIcon,
  },
  {
    name: "Menu Templates",
    url: PROTECTED + MENU_TEMPLATES,
    icon: FormatListBulletedOutlinedIcon,
  },
  {
    name: "Semester Menus",
    url: PROTECTED + SEMESTER_MENUS,
    icon: ViewListIcon,
  },
  {
    name: "Upcoming Meals",
    url: PROTECTED + UPCOMING_MEALS,
    icon: CalendarMonthIcon,
  },
];

export const settings = [
  {
    name: "Meal Times",
    url: PROTECTED + TIMES,
    icon: CalendarMonthIcon,
  },
  {
    name: "Holidays",
    url: PROTECTED + HOLIDAYS,
    icon: ParkIcon,
  },
  {
    name: "Term Holidays",
    url: PROTECTED + TERM_HOLIDAYS,
    icon: EventBusyIcon,
  },
  {
    name: "Residences",
    url: PROTECTED + RESIDENCES,
    icon: HotelIcon,
  },
  {
    name: "Meal Bookings",
    url: PROTECTED + MEAL_BOOKING_SETTINGS,
    icon: MenuBookIcon,
  },
  {
    name: "Account Balance",
    url: PROTECTED + BALANCE,
    icon: AccountBalanceIcon,
  },
  {
    name: "System",
    url: PROTECTED + SYSTEM,
    icon: ConfirmationNumberIcon,
  },
];
